import React, {useEffect} from "react";
import SectionContainer from "../layouts/SectionContainer";
import Timeline from "../components/Timeline";
import "../scss/history.scss";

const History = () => {

  useEffect(() => {
    document.title = "L'histoire de Cartésia Junior";
  });

  return (
    <div>
      <SectionContainer>
        <div className="master-wrapper">
          <div className="master-head">
            <h1 className="page-title">Cartésia Junior</h1>
            <p className="page-description">
            Notre association étudiante est la plus jeunes de notre campus (l'IUT de Paris), et peut-être aussi l'une des plus innovantes ! <br/>
            Nous vous détaillons son histoire, dont les débuts ont été particulièrement marqués par des problèmes de démarches administratives.
            </p>
          </div>
        </div>
      </SectionContainer>
      <SectionContainer>
        <Timeline id="timeline" />
      </SectionContainer>
    </div>
  );
};

export default History;
